import axios from 'axios';

export default {
	getCaptcha() {
		return axios.get('/apps/babyloan/api/captcha');
	},
	postBabyloanRegistration(data) {
		return axios.post('/apps/babyloan/api', data);
	},
	calculatorInit(amount) {
		return axios.get('/apps/babyloan/api/calculator/init', {
			params: {
				kolcsonOsszeg: amount
			}
		});
	},
	calculatorGetResults(amount) {
		return axios.get('/apps/babyloan/api/calculator/data', {
			params: {
				kolcsonOsszeg: amount
			}
		});
	}
};
